<template>
  <div style="width: 100%;">
    <div v-if="sessionModes && sessionModes.length > 0">
      <draggable v-model="sessionModes" v-bind="dragOptions" @end="onDragEnd">
        <transition-group type="transition" name="flip-list">
          <div
              v-for="(sessionMode, idx) in sessionModes"
              :key="sessionMode.uuid"
          >
            <v-row>
              <v-col v-if="editionMode" class="draggable-item" md="1">
                <v-icon :class="editionMode ? 'draggable' : ''">{{ editionMode ? 'mdi-drag' : 'mdi-blank' }}</v-icon>
              </v-col>
              <v-col class="mx-2">
                 <CampaignSessionMode 
                  :editionMode="editionMode"
                  :sessionMode="sessionMode" 
                  :sessionModeIdx="idx"
                  :jsonpath="`${jsonpath}[${idx}]`"
                  @change="onChange"
                  @delete="onDelete"
                  :availableRoles="availableRoles"
                ></CampaignSessionMode>
              </v-col>
            </v-row>
          </div>
        </transition-group>
      </draggable>
    </div>
    <div v-if="editionMode && (!maxSessionModes || sessionModes.length < maxSessionModes)" >
      <a @click="createSessionMode">{{ $t('campaigns.label.createSessionMode') }}</a>
    </div>
  </div>  
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import CampaignSessionMode from "./CampaignSessionMode"
import draggable from "vuedraggable";

export default {
  props: ["editionMode", "sessionModes", "maxSessionModes", "jsonpath"],
  components: {
    CampaignSessionMode,
    draggable,
  },
  data() {
    return {
      availableRoles: [],
    }
  },
  mounted() {
    const self = this;
    const mount = async function() {
     const availableRoles = await self.$store._getRoles()
     availableRoles.filter(role => role.type == "functional").forEach(functionalRole => {
       self.availableRoles.push(functionalRole)
     });
    }
    mount()
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: !this.editionMode,
        ghostClass: "ghost"
      };
    },
  },
  methods: {
    onDragEnd(evt) {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "move", value: {
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex,
      }}})
    },
    onChange(event) {
      this.$emit("change", event)
    },
    onDelete(event) {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "remove", value : event }})
    },
    createSessionMode() {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "add", value: {
        uuid: uuidv4(),
        label: "",
        openFunctionalRoles: [],
        startedFunctionalRoles: [],
      }}})
    },
  }
}
</script>
